// import { useState, useRef, useEffect } from 'react';
import classes from './Badge.module.scss';
// import { useResize } from '../../../utils/useResize';

//for width, push a default of auto if you dont want it set.

export default function Badge(props) {
    const { theme, text, width, onClick, hasBorder = false } = props;
    // const [badgeWidth, setBadgeWidth] = useState(width);
    // const ref = useRef();
    // const resize = useResize(ref);

    // useEffect(() => {
    //     if (resize) {
    //         setBadgeWidth('inline');
    //     }
    // }, [resize]);

    return (
        <div
            // ref={ref}
            id={`${text}`}
            className={`${classes.aBadge} ${classes[`${width}`]} ${classes[`${theme}`]} ${
                classes[`${hasBorder && 'badgeBorder'}`]
            } fnt16f`}
            onClick={(event) => {
                onClick ? onClick(event) : null;
            }}
        >
            {text}
        </div>
    );
}
